<template>
  <div class="col-12">
    <ul class="nav nav-tabs">
      <li
        v-for="tab in tabs"
        :key="tab"
        :class="{
          invalid:
            (tab === 'Details' && $v.details.$anyError) ||
            (tab === 'Surveys' && surveysTabIsInvalid) ||
            (tab === 'Certifications' && certificatesTabIsInvalid),
        }"
        class="nav-item"
      >
        <a
          :class="{ active: active_tab === tab }"
          class="nav-link"
          href="#"
          @click.prevent="setTab(tab)"
        >
          {{ tab }}
        </a>
      </li>
    </ul>
    <div class="card">
      <div class="card-body">
        <!-- Surveys -->
        <surveys-tab
          v-show="active_tab === 'Surveys'"
          ref="tabSurveys"
          :vessel="vessel"
        />
        <certifications-tab
          v-show="active_tab === 'Certifications'"
          ref="tabCertifications"
          :vessel="vessel"
        />
        <hull-and-machinery-tab
          v-show="active_tab === 'H&M'"
          ref="tabHullAndMachinery"
          :vessel="vessel"
        />
        <valuations-tab
          v-show="active_tab === 'Insurance & Valuation'"
          ref="tabValuations"
          :vessel="vessel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SurveysTab from "./SurveysTab.vue";
import ValuationsTab from "./ValuationsTab.vue";
import HullAndMachineryTab from "./hullAndMachinery/HullAndMachineryTab.vue";
import CertificationsTab from "./CertificationsTab.vue";

export default {
  name: "VesselsSurveysAndCertsTab",
  components: {
    SurveysTab,
    CertificationsTab,
    ValuationsTab,
    HullAndMachineryTab,
  },
  props: {
    vessel: Object,
  },
  data() {
    return {
      tabs: ["Surveys", "Certifications", "H&M", "Insurance & Valuation"],
      active_tab: "Surveys",

      surveysTabIsInvalid: false,
      certificatesTabIsInvalid: false,
    };
  },
  watch: {
    // Watch $route in case route changes or refreshes dynamically
    "$route.query.tab": {
      immediate: true,
      handler(newTab) {
        if (newTab && this.tabs.includes(newTab)) {
          this.active_tab = newTab;
        }
      },
    },
  },
  methods: {
    setTab(tab) {
      this.active_tab = tab;

      // Update URL query parameter without re-triggering navigation errors
      if (this.$route.query.tab !== tab) {
        this.$router
          .replace({
            query: { ...this.$route.query, tab },
          })
          .catch(() => {});
      }
    },
    isInvalid() {
      this.surveysTabIsInvalid = this.tabSurveys.isInvalid();
      this.certificatesTabIsInvalid = this.tabCertifications.isInvalid();
      return this.surveysTabIsInvalid || this.certificatesTabIsInvalid;
    },
  },
  computed: {
    tabSurveys() {
      return this.$refs.tabSurveys;
    },
    tabCertifications() {
      return this.$refs.tabCertifications;
    },
    tabValuations() {
      return this.$refs.tabValuations;
    },
    tabHullAndMachinery() {
      return this.$refs.tabHullAndMachinery;
    },
  },
};
</script>
